import http, { getUrl } from '../client'
import type { UploadFileResponse } from './file.d'

export function uploadFile(data: FileList | File[], folder?: number) {
  const fd = new FormData()
  for (let i = 0; i < data.length; i += 1) {
    fd.append('fileList', data[i])
  }
  if (folder) {
    fd.append('folderId', folder as any)
  }
  return http<UploadFileResponse[]>({
    url: '/cad/api/file/upload-file',
    data: fd,
  })
}

export function uploadFileLarge(data: FileList | File[], folder?: number) {
  const fd = new FormData()
  for (let i = 0; i < data.length; i += 1) {
    fd.append('fileList', data[i])
  }
  if (folder) {
    fd.append('folderId', folder as any)
  }
  return http<UploadFileResponse[]>({
    url: '/cad/api/file/upload-file-large',
    data: fd,
  })
}

export function previewFile(uuid?: string) {
  if (!uuid) return ''
  return getUrl(`/cad/api/file/preview-file/${uuid}`)
}

export function getFile(uuid: string) {
  return http<UploadFileResponse>({
    url: `/cad/api/file/get-file/${uuid}`,
    method: 'get',
    data: undefined,
  })
}

export function deleteFile(uuid: string) {
  return http<UploadFileResponse>({
    url: `/cad/api/file/delete-file/${uuid}`,
    method: 'get',
    data: undefined,
  })
}

export function getPreviewUrl(uuid: string) {
  return http<string>({
    url: `/cad/api/file/get-preview-url/${uuid}`,
    method: 'get',
  })
}

export function listFilesByFolder(id: number) {
  return http<UploadFileResponse[]>({
    url: `/cad/api/file/list-files-by-folder`,
    method: 'post',
    data: { id },
  })
}

export async function copyFile(f: UploadFileResponse, folderId: number) {
  const res = await fetch(previewFile(f.uuid))
  const blob = await res.blob()
  const file = new File([blob], [f.name, f.format].join('.'), {
    type: blob.type,
  })
  const fs = await uploadFileLarge([file], folderId)
  return fs[0]
}
